import React from "react";
import classes from "./Book.module.css";
import Button from "react-bootstrap/Button";
import "./Book.css";

const Book = () => {
  return (
    <div className={classes.Intro}>
      <a class="Book" href="https://amplifynewmarket.janeapp.com/">
        <Button
          variant="default"
          style={{
            background: "black",
            color: "#c5c7d1",
            width: "200px",
            height: "50px",
            fontWeight: "bold"
          }}
        >
          BOOK NOW!
        </Button>
      </a>
    </div>
  );
};

export default Book;
